import React from 'react';
import { FaStore } from 'react-icons/fa';
import { useI18n } from '../../contexts/I18n';
import { cleanText } from './utils';

export default function ProfileView({ biz, onEdit, imageHandler, tempPassword }) {
  const { t } = useI18n();

  const staffList =
    Array.isArray(biz?.staff) && biz.staff.length
      ? biz.staff
      : Array.isArray(biz?.staffMembers) && biz.staffMembers.length
        ? biz.staffMembers
        : [];

  return (
    <div className="shopowner-profile-card">
      <div className="shopowner-profile-header">
        <div className="shopowner-profile-header-content">
          <h2 className="shopowner-profile-title-row">
            <span className="tab-title-icon-wrap" aria-hidden="true">
              <FaStore className="shopowner-profile-title-icon" size={18} />
            </span>
            {t('ownerBizProfile')}
          </h2>
          <p className="shopowner-profile-subtitle">{t('ownerBizProfileSub')}</p>
        </div>
        <button
          className="edit-btn"
          onClick={() => onEdit?.()}
        >
          <span className="edit-btn-text">{t('ownerEditProfile')}</span>
        </button>
      </div>

      <div className="shopowner-profile-info-grid">
        <div className="profile-info-item">
          <div className="profile-info-label">{t('ownerBusinessName')}</div>
          <div className="profile-info-value">{biz.name}</div>
        </div>
        <div className="profile-info-item">
          <div className="profile-info-label">{t('ownerLocation')}</div>
          <div className="profile-info-value">{biz.town}</div>
        </div>
        <div className="profile-info-item">
          <div className="profile-info-label">{t('ownerPhone')}</div>
          <div className="profile-info-value">{biz.phone}</div>
        </div>
        <div className="profile-info-item">
          <div className="profile-info-label">{t('ownerCategory')}</div>
          <div className="profile-info-value">{biz.serviceCategory}</div>
        </div>
      </div>

      {tempPassword && (
        <div className="shopowner-profile-info-grid" style={{ marginTop: 16 }}>
          <div className="profile-info-item">
            <div className="profile-info-label">{t('currentPassword')}</div>
            <div className="profile-info-value">{tempPassword}</div>
          </div>
        </div>
      )}

      <div className="shopowner-profile-images-section">
        <h3 className="section-title">{t('ownerImages')}</h3>
        <div className="business-images-gallery">
          {(() => {
            const allImages = [];
            if (biz.imageUrl) allImages.push(biz.imageUrl);
            if (biz.gallery && Array.isArray(biz.gallery)) allImages.push(...biz.gallery);

            if (allImages.length === 0) {
              return (
                <div className="no-images-placeholder">
                  <span>📷</span>
                  <p>{t('ownerNoImages')}</p>
                </div>
              );
            }

            return allImages.map((img, idx) => (
              <div key={idx} className="business-image-item">
                <img
                  src={imageHandler.getUrl(img)}
                  alt={`${biz.name} ${idx + 1}`}
                  className="business-image"
                  onError={(e) => imageHandler.handleError(e, img)}
                  onLoad={(e) => imageHandler.handleLoad(e, img)}
                />
              </div>
            ));
          })()}
        </div>
      </div>

      <div className="shopowner-services-section">
        <h3 className="section-title">{t('ownerServices')}</h3>
        <div className="services-list">
          {(biz.services || []).map((s) => (
            <div key={s._id || s.serviceName} className="service-item">
              <div className="service-name">{s.serviceName}</div>
              <div className="service-price">{cleanText(`${Number(s.price).toLocaleString('en-US')} EGP`)}</div>
            </div>
          ))}
        </div>
      </div>

      {staffList.length > 0 && (
        <div className="shopowner-staff-section">
          <h3 className="section-title">{t('ownerStaffMembers')}</h3>
          <div className="staff-grid">
            {staffList.map((st, i) => (
              <div key={st._id || st.name || i} className="staff-card">
                <div className="staff-name">{st.name}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
